/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

/*
* Display  Content Upload Window
*/
import React, { Component } from 'react';
import { TEXT_TYPES } from "../../../constants/APP_CONSTANTS";
import MutiFileUploadComponent from '../../widgets/FileUploadDisplay/MutiFileUploadComponent';
import MultifileUploadSelectcomponent from "./MultifileUploadSelectcomponent";
import AxiosClient from '../../../_helpers/http.helper';
import config from "../../../config";
import urlHelper from '../../../_helpers/url.format.helper';
import ModalDialog from "../../widgets/ModalDialog/ModalDialog";
import { Redirect } from 'react-router';

export default class UploadContentComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            file: "",
            formData: "",
            showPopup: false,
            statusModal: false,
            toViewContentIngestionStatus: false,
            percentage: 0,
            batchUploads: [],
            showBatchCompletePopup: false,
            batchStatus: "",
            failedMsg: [],
            showBatchStatus: [],
            disableImport: true,
            disableAddFiles: true,
            fileUploadTpye:"replace" ,
            resourceType: "scrubbed",
            fileObj : "",
            fileArray : [],
            newupload: false,
            replacepdf: false,
           
            dropdown_selected: [
                { label: 'Content Type', value: 'Select Content Type'},
                { label: 'Source', value: 'Pearson' },
                { label: 'Sub Type', value: 'CSG' },
                { label: 'Unscrubbed', value: 'false' },
                { label: 'newupload', value: 'false' },
                { label: 'replace', value: 'false' },

            ],
            enableImport: this.enableImport.bind(this),
            disableImportAction: this.disableImportAction.bind(this), 
            disableAddFilesAction: this.disableAddFilesAction.bind(this), 
            enableAddFiles:this. enableAddFiles.bind(this)      
        };

        this.showPopup = this.showPopup.bind(this);
        this.changeDropdownSelected = this.changeDropdownSelected.bind(this);
    }
    handleFileTypeOptionChange(e) {
        this.setState({ disableAddFiles: false });
        this.setState({
            fileUploadType: e.target.value
        });
        if (e.target.value === 'newupload') {
            this.changeDropdownSelected(4,false);
        }
        if(e.target.value === 'replace') 
        {
            this.changeDropdownSelected(4,true);
        }
    }
    popupFileWindow() {
        document.getElementById("fileLoader").click();
    }

    handleChange(e) {
       
        let AllowFileFormats = ['pdf','PDF'];
        let FileName = '';
        let importDisable = false;
        const files = [...e.target.files];
        let fileSize = 0;
        //const labels =[...e.target.label];

        if (files.length > 25) {
            alert ('Maximum 25 files can be selected');
            importDisable = true;
            return false;
        }
        const  fMsgs = [], fileArray=[], ufiles= [];
        files.forEach((file, idx) => {
            FileName = file.name;
            AllowFileFormats = FileName.substr(FileName.lastIndexOf('.')+1, FileName.length);
            if(AllowFileFormats!== "pdf" &&  AllowFileFormats!== "PDF"){
                alert('Not a valid file type.Please select .pdf file');
                importDisable = true;
                return false;
            } 
            if((this.state.dropdown_selected[0].value === 'Texts' || 'Cases') && (this.state.dropdown_selected[3].value == true) && !(FileName.toUpperCase().includes('_PCUS'))) {
                alert('Not a valid file name. Please make sure scrubbed pdf file name do not end with "_PCUS" and unscrubbed pdf file end with "_PCUS"');
                importDisable = true;
                return false;
            }
            if((this.state.dropdown_selected[0].value === 'Texts'|| 'Cases') && !(this.state.dropdown_selected[3].value == true) && (FileName.toUpperCase().includes('_PCUS'))) {
                alert('Not a valid file name. Please make sure scrubbed pdf file name do not end with "_PCUS" and unscrubbed pdf file end with "_PCUS"');
                importDisable = true;
            } else if (!(/^\S{3,}$/.test(FileName))) {              
                alert('File name cannot contain whitespace');
                importDisable = true;
                return false;
            } else {
                fMsgs.push('');
                fileArray.push(FileName);
                ufiles.push(file);
            }
            fileSize+=file.size;
        });
      
        if (this.convertToGB(fileSize) > 1) {
            alert('Maximum upload size allowed is 1 GB');
            return false;
        }

        this.setState({ showBatchStatus: 'New', failedMsg: fMsgs, fileArray, ufiles }); 
        if (importDisable && ufiles.length !== 0) {
            importDisable = false;
        } 
        this.setState({ disableImport: importDisable });
    
        if(this.state.dropdown_selected[0].value === 'Select Content Type'){
            this.setState({ disableImport: true });  
        }
    }

    showPopup() {
        this.setState({ showPopup: true });
        this.setState({ showBatchStatus: 'New'});
        this.setState({ failedMsg: [] });
    }

    closePopup() {
        this.setState({ showPopup: false });
    }

    showBatchCompletePopup() {
        this.setState({ showBatchCompletePopup: true });
    }

    changeUploadProgress() {
        this.setState({ percentage: 100 });
    }

    changeDropdownSelected(index, value){
        const dropdown_selected_copy = [...this.state.dropdown_selected];
        dropdown_selected_copy[index].value = value;
        this.setState({dropdown_selected: dropdown_selected_copy});
    }
    
    enableImport() {
        this.setState({ disableImport: false });  
    }

    disableImportAction() {
        this.setState({ disableImport: true });  
    }
    disableAddFilesAction() {
        this.setState({ disableAddFiles: true });  
    }
    enableAddFiles() {
        this.setState({ disableAddFiles: false });  
    }

    axiosRequest() {
        this.closePopup();
        const options = {
        };
        let searchRoute = config.contentService.routes.uploadContent;
        const url = urlHelper.formatUrl(
            config.contentService.baseUrl,
            searchRoute,
            {
                queryParams: {
                    "contentType": this.state.dropdown_selected[0].value,
                    "source": this.state.dropdown_selected[1].value,
                    "subType": this.state.dropdown_selected[2].value,
                    "unscrub": this.state.dropdown_selected[3].value,
                    "replace":this.state.dropdown_selected[4].value,
                },
            }
        );
        this.coverLinkTimeout = setInterval(() => {
            if (this.state.percentage < 90) {
                this.setState({ percentage: this.state.percentage + 5 });
            }
        }, 2000);
        const formData = new FormData();
        this.state.ufiles.forEach((file) => {
            formData.append('files', file);
        });
        AxiosClient.post(url, formData, { "headers": { "content-type": "multipart/form-data"}})
            .then(response => {
                this.changeUploadProgress();
                setTimeout(() => {
                    this.setState({ percentage: 0 });
                    if (this.coverLinkTimeout) {
                        clearInterval(this.coverLinkTimeout);
                    }
                    this.setState({ disableImport: true });
                    this.setState({ showBatchStatus: this.state.batchStatus });
                    this.setState({ showBatchCompletePopup: false });
                }, 500);
                const batchUploads = [];
                response.data.forEach((item, i) => {
                    batchUploads.push({
                        batchId: item.batchId,
                        fileName: this.state.fileArray[i],
                    });
                });
                this.setState({ batchUploads });
                this.setState({
                    batchStatus: TEXT_TYPES.SUCCESS_MSG,
                    statusModal: true
                });

            })
            .catch(error => {
                console.log("Error");
                if (error.response) {
                    this.changeUploadProgress();
                    setTimeout(() => this.setState({ percentage: 0 }), 500);
                    this.setState({ batchStatus: TEXT_TYPES.FAILED_MSG });
                    if(typeof error.response.data.message === 'object'){
                        this.setState({ failedMsg: " (" + (error.response.data.message)[Object.keys(error.response.data.message)[0]] + ")" });
                    }
                    else{
                        this.setState({ failedMsg: " (" + error.response.data.message + ")" });    
                    }
                }
                else {
                    this.setState({ batchStatus: TEXT_TYPES.FAILED_MSG });
                }
                if (this.coverLinkTimeout) {
                    clearInterval(this.coverLinkTimeout);
                }
                this.setState({ disableImport: true });
                this.setState({ showBatchStatus: this.state.batchStatus });
                return error;
            });
    }

    closeModal =()=>{
        this.setState({
            statusModal: false
        });
    };

    navigateToStatusPage = () => {
        this.setState({
            toViewContentIngestionStatus: true
        });
    };
    
    convertToGB(byteValue){
        return (byteValue / (1024 * 1024 * 1024)).toFixed(2);
    }

    render() {
        if (this.state.toViewContentIngestionStatus) {
            return <Redirect to='/content-update-status'/>;
        }
        return (
            <div className="upload-metadata-page">
                <div>
                    <label className="pe-page-title--small">{TEXT_TYPES.UPLOAD_CONTENT}</label>
                    <hr /> 
                    <div>
                        <div className='pe-col-2 radio-btn '>
                            <div className="pe-radio scrubbed">
                                <input type="radio" name="file-type" id="newupload" value='newupload' 
                                    checked={this.state.fileUploadType === 'newupload' ? true : false}
                                    onChange={(e) => this.handleFileTypeOptionChange(e)} />
                                <label htmlFor="newupload">New File(s) Upload</label>
                                <span>
                                    <svg aria-hidden="true" focusable="false" className="pe-icon--radio-dot">
                                        <use xlinkHref="#new-notification-9"></use>
                                    </svg>
                                </span>
                            </div>
                        </div>                    
                        <div className='pe-col-2 radio-btn'>
                            <div className="pe-radio unscrubbed">
                                <input type="radio" name="file-type" id="replace" value='replace'  
                                    checked={this.state.fileUploadType === 'replace' ? true : false}
                                    onChange={(e) => this.handleFileTypeOptionChange(e)} />
                                <label htmlFor="replace">Replace Existing File(s)</label>
                                <span>
                                    <svg aria-hidden="true" focusable="false" className="pe-icon--radio-dot">
                                        <use xlinkHref="#new-notification-9"></use>
                                    </svg>
                                </span>
                            </div>                            
                        </div>
                        <div className='te' style={{clear:'both'}}></div>
                    </div>
                    <div>
                        <label className="hint1" >{TEXT_TYPES.SELECT_METADATA_NOTE}</label>
                    </div>
                    <MultifileUploadSelectcomponent dropdown_selected={this.state.dropdown_selected} enableImport={this.state.enableImport} enableUnsrubbed={this.state.enableUnsrubbed} disableImportAction={this.state.disableImportAction} disableUnsrubbed={this.state.disableUnsrubbed}fileSelected={this.state.file}  changeDropdownSelected={this.changeDropdownSelected} />
                </div>
                {this.state.fileArray.length !=0
                    && <MutiFileUploadComponent fileArray={this.state.fileArray} percentage={this.state.percentage} showBatchStatus={this.state.showBatchStatus} failedMsg={this.state.failedMsg} changeDropdownSelected={this.changeDropdownSelected}/>
                }
                <ModalDialog
                    title={TEXT_TYPES.UPLOAD_CONTENT_CONFIRMATION}
                    showModal={this.state.showPopup}
                    onCancel={this.closePopup.bind(this)}
                    onSuccess={this.axiosRequest.bind(this)}
                    successText="OK">
                    <div className="metadata-edit-dialog">
                        <p>
                            {TEXT_TYPES.UPLOAD_CONTENT_CONFIRMATION_MSG.replace("$file", this.state.file)}
                        </p>
                    </div>
                </ModalDialog>

                <ModalDialog
                    title={TEXT_TYPES.UPLOAD_SUMMARY}
                    showModal={this.state.statusModal}
                    onCancel={this.closeModal}
                    onSuccess={this.navigateToStatusPage}
                    successText={"View Status here"}
                >
                    <p> Your file is being uploaded.The batch id is given below</p>
                    <div className="uploadfiles-table">
                        <div className="uploadfiles-headers">
                            <span>File Name</span>
                            <span>Batch ID</span>
                        </div>
                        <div className="uploadfiles-lists">
                            {(this.state.batchUploads.map((item,index) => <div className="uploadfiles-listitem" key={index}>
                                <span>{`${index+1}. ${item.fileName}`}</span>
                                <span>{item.batchId}</span></div>))}
                        </div>
                    </div>
                    {/* <p>{TEXT_TYPES.UPLOAD_METADATA_SUCCESS_MSG.replace("$file", this.state.fileArray).replace("$batchId", this.state.batchId)}</p> */}
                </ModalDialog>
                <label className="pe-col-12 hint2" >{TEXT_TYPES.UPLOAD_CONTENT_NOTE}</label>
                <div className="pe-col-12 fileLoad">
                    <div className="buttons">
                        <input multiple type="file" id="fileLoader" name="files" title="Load File" onClick={(event) => { event.target.value = null; }} onChange={this.handleChange.bind(this)} />
                        <button type="file" name="files" className="pe-btn selectBtn " disabled={this.state.disableAddFiles} onClick={this.popupFileWindow.bind(this)}>Add Files</button>
                    </div>
                    <div className="buttons">                        
                        <button className="pe-btn pe-btn__primary" disabled={this.state.disableImport} onClick={this.showPopup}>Import</button>
                    </div>
                </div>
            </div >
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/ContentIngestion/UploadContentComponent.js